export const PHONE = "+918107172107";
export const PHONE_DISPLAY = "+91 8107172107";
export const WHATSAPP = "918107172107";
export const EMAIL = "mamtatourntravels@gmail.com";
export const ADDRESS =
  "2nd, No. 6, Opposite AIIMS Road, MIA 2nd Phase, Basni, Jodhpur, Rajasthan 342005";

export function whatsappLink(message = "") {
  const base = `https://wa.me/${WHATSAPP}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
}

export function buildBookingMessage(data) {
  const lines = [
    "*New Booking Request — Mamta Tours & Travels*",
    "",
    `Name: ${data.name || "-"}`,
    `Mobile: ${data.mobile || "-"}`,
    `Pickup: ${data.pickup_location || "-"}`,
    `Drop: ${data.drop_location || "-"}`,
    `Date: ${data.pickup_date || "-"}`,
    `Time: ${data.pickup_time || "-"}`,
    `Vehicle: ${data.vehicle_type || "-"}`,
    `Notes: ${data.message || "-"}`,
  ];
  return lines.join("\n");
}

export function telLink() {
  return `tel:${PHONE}`;
}
